import { DEFAULT_PAGE_SIZE } from './common/constants';

export const calculateMaximumPage = (pageSize: number = DEFAULT_PAGE_SIZE, total = 0): number =>
	Math.ceil(total / pageSize);
